import { Flex, Icon, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiClock } from "react-icons/fi";

export const EarlyAccessNote = () => {
  const { t } = useTranslation();
  return (
    <Flex align="center" gap="2" fontSize="sm" color="smMuted">
      <Icon as={FiClock} flexShrink={0} />
      <Text>{t("Bids delivered so far are open to you while the competition is still running.")}</Text>
    </Flex>
  );
};
